import React from "react";

import ShowContactInfo from "./show-contact-info";


export default {
    ShowContactInfo: { node: <ShowContactInfo /> },
};

